import { ReactNode } from 'react';

type DescriptionItem = {
  term: ReactNode;
  description: ReactNode | ReactNode[];
};

type NsDescriptionListProps = {
  children?: (DescriptionItem | ReactNode)[];
  className?: 'dl-row' | 'dl-stack';
  testId?: string;
};

export const NsDescriptionList = ({
  children = [],
  className = 'dl-row',
  testId = 'descriptionListTestId'
}: NsDescriptionListProps) => {
  return (
    <dl className={className} data-testid={testId}>
      {children.map((item, index) => {
        if (!item) {
          return null;
        }
        const { term, description } = item as DescriptionItem;

        return (
          <div key={index}>
            <dt>{term}</dt>
            {Array.isArray(description) ? (
              description.map((dd, index) => <dd key={index}>{dd}</dd>)
            ) : (
              <dd>{description}</dd>
            )}
          </div>
        );
      })}
    </dl>
  );
};
